module.exports = __webpack_public_path__ + "img/icon-confirm-full.e9a56b47.svg";